/**
 * Enum for event type
 * @readonly
 * @enum {string}
 */
export const types = Object.freeze({
	BOUNDARY_STATUS: 'BOUNDARY_STATUS',
	CHART_NOT_AVAILABLE: 'CHART_NOT_AVAILABLE',
	CLICK_RIGHT: 'CLICK_RIGHT',
	CLICK_START: 'CLICK_START',
	CLICK: 'CLICK',
	COMPARISON_ADD: 'COMPARISON_ADD',
	CROSSHAIR_HIDE: 'CROSSHAIR_HIDE',
	CROSSHAIR_MOVE: 'CROSSHAIR_MOVE',
	CROSSHAIR_SHOW: 'CROSSHAIR_SHOW',
	CURSOR_CHANGE: 'CURSOR_CHANGE',
	DATA_DENSITY: 'DATA_DENSITY',
	DATA_ELEMENT_ERROR: 'DATA_ELEMENT_ERROR',
	DATA_FRAME_UPDATE: 'DATA_FRAME_UPDATE',
	DATA_LOAD_COMPLETE: 'DATA_LOAD_COMPLETE',
	DATA_LOAD_ERROR: 'DATA_LOAD_ERROR',
	DATA_LOAD_START: 'DATA_LOAD_START',
	DATA_LOAD_STOP: 'DATA_LOAD_STOP',
	DATA_POLL_ERROR: 'DATA_POLL_ERROR',
	DATA_PREPEND_ERROR: 'DATA_PREPEND_ERROR',
	DATA_PRESENT: 'DATA_PRESENT',
	DOUBLE_CLICK: 'DOUBLE_CLICK',
	EVENT_ADD: 'EVENT_ADD',
	EVENT_MOUSE_ENTER: 'EVENT_MOUSE_ENTER',
	EVENT_MOUSE_LEAVE: 'EVENT_MOUSE_LEAVE',
	EVENT_REMOVE: 'EVENT_REMOVE',
	EVENT_RENDER: 'EVENT_RENDER',
	EXPORT_CANVAS_END: 'EXPORT_CANVAS_END',
	EXPORT_CANVAS_START: 'EXPORT_CANVAS_START',
	FLAG_HIDE_CROSSHAIR: 'FLAG_HIDE_CROSSHAIR',
	FLAG_HIDE_HORIZ_ANNOTATION: 'FLAG_HIDE_HORIZ_ANNOTATION',
	FLAG_HIDE_INDICATOR: 'FLAG_HIDE_INDICATOR',
	FLAG_HIDE_LASTCLOSE: 'FLAG_HIDE_LASTCLOSE',
	FLAG_HIDE_XAXIS: 'FLAG_HIDE_XAXIS',
	FLAG_RENDER_CROSSHAIR: 'FLAG_RENDER_CROSSHAIR',
	FLAG_RENDER_HORIZ_ANNOTATION: 'FLAG_RENDER_HORIZ_ANNOTATION',
	FLAG_RENDER_INDICATOR: 'FLAG_RENDER_INDICATOR',
	FLAG_RENDER_LASTCLOSE: 'FLAG_RENDER_LASTCLOSE',
	FLAG_RENDER_XAXIS: 'FLAG_RENDER_XAXIS',
	FLAG_SHOW_CROSSHAIR: 'FLAG_SHOW_CROSSHAIR',
	FLAG_SHOW_HORIZ_ANNOTATION: 'FLAG_SHOW_HORIZ_ANNOTATION',
	FLAG_SHOW_INDICATOR: 'FLAG_SHOW_INDICATOR',
	FLAG_SHOW_LASTCLOSE: 'FLAG_SHOW_LASTCLOSE',
	FLAG_SHOW_XAXIS: 'FLAG_SHOW_XAXIS',
	IMAGE_SAVE_ERROR: 'IMAGE_SAVE_ERROR',
	IMAGE_SAVE_SUCCESS: 'IMAGE_SAVE_SUCCESS',
	INDICATOR_BESTWORST_UPDATE: 'INDICATOR_BESTWORST_UPDATE',
	INDICATOR_HIGHLOW_RENDER: 'INDICATOR_HIGHLOW_RENDER',
	INDICATOR_INPUT_UPDATE: 'INDICATOR_INPUT_UPDATE',
	INDICATOR_LOWER_ADD: 'INDICATOR_LOWER_ADD',
	INDICATOR_LOWER_REMOVE: 'INDICATOR_LOWER_REMOVE',
	INDICATOR_MOUSE_MOVE: 'INDICATOR_MOUSE_MOVE',
	INDICATOR_MOUSE_OUT: 'INDICATOR_MOUSE_OUT',
	INDICATOR_MOUSE_OVER: 'INDICATOR_MOUSE_OVER',
	INDICATOR_PARAM_UPDATE: 'INDICATOR_PARAM_UPDATE',
	INDICATOR_REGIONSERIES_MOUSE_OUT: 'INDICATOR_REGIONSERIES_MOUSE_OUT',
	INDICATOR_REGIONSERIES_MOUSE_OVER: 'INDICATOR_REGIONSERIES_MOUSE_OVER',
	INDICATOR_STYLE_UPDATE: 'INDICATOR_STYLE_UPDATE',
	INDICATOR_UPPER_ADD: 'INDICATOR_UPPER_ADD',
	INDICATOR_UPPER_REMOVE: 'INDICATOR_UPPER_REMOVE',
	KEY_DOWN: 'KEY_DOWN',
	KEY_UP: 'KEY_UP',
	LONG_DOUBLE_PRESS: 'LONG_DOUBLE_PRESS',
	LONG_PRESS: 'LONG_PRESS',
	MOUSE_DOWN: 'MOUSE_DOWN',
	MOUSE_ENTER: 'MOUSE_ENTER',
	MOUSE_LEAVE: 'MOUSE_LEAVE',
	MOUSE_MOVE: 'MOUSE_MOVE',
	MOUSE_UP: 'MOUSE_UP',
	PANEL_LEGEND_UPDATE: 'PANEL_LEGEND_UPDATE',
	PANEL_MOUSE_MOVE: 'PANEL_MOUSE_MOVE',
	PANEL_SCALE_CHANGE: 'PANEL_SCALE_CHANGE',
	PRICE_MARKER_TYPE_SET: 'PRICE_MARKER_TYPE_SET',
	RENDER: 'RENDER',
	RESIZE_HANDLE_HOVER: 'RESIZE_HANDLE_HOVER',
	RESIZE: 'RESIZE',
	SAVE_COMPLETE: 'SAVE_COMPLETE',
	SESSION_RENDER: 'SESSION_RENDER',
	SYMBOL_UPDATE: 'SYMBOL_UPDATE',
	TEMPLATE_APPLY: 'TEMPLATE_APPLY',
	TEMPLATE_LOAD_ERROR: 'TEMPLATE_LOAD_ERROR',
	TEMPLATE_LOAD: 'TEMPLATE_LOAD',
	TEMPLATE_SAVE_COMPLETE: 'TEMPLATE_SAVE_COMPLETE',
	TIME_SERIES_SET: 'TIME_SERIES_SET',
	TOOL_ADD: 'TOOL_ADD',
	TOOL_DOUBLE_CLICK: 'TOOL_DOUBLE_CLICK',
	TOOL_HANDLE_MOUSE_ENTER: 'TOOL_HANDLE_MOUSE_ENTER',
	TOOL_HANDLE_MOUSE_LEAVE: 'TOOL_HANDLE_MOUSE_LEAVE',
	TOOL_MODE_CHANGE: 'TOOL_MODE_CHANGE',
	TOOL_MOUSE_DOWN: 'TOOL_MOUSE_DOWN',
	TOOL_MOUSE_ENTER: 'TOOL_MOUSE_ENTER',
	TOOL_MOUSE_LEAVE: 'TOOL_MOUSE_LEAVE',
	TOOL_MOUSE_MOVE: 'TOOL_MOUSE_MOVE',
	TOOL_MOUSE_UP: 'TOOL_MOUSE_UP',
	TOOL_OHLCCROSSHAIR_RENDER: 'TOOL_OHLCCROSSHAIR_RENDER',
	TOOL_REMOVE: 'TOOL_REMOVE',
	TOOL_RENDER: 'TOOL_RENDER',
	TOOL_SELECT: 'TOOL_SELECT',
	TOUCH_END: 'TOUCH_END',
	TOUCH_MOVE: 'TOUCH_MOVE',
	TOUCH_START: 'TOUCH_START',
	WINDOW_RESIZE: 'WINDOW_RESIZE',
	ZOOM_END: 'ZOOM_END',
	ZOOM: 'ZOOM',
	ZOOM_START: 'ZOOM_START'
});

/**
 * Enums associated with events
 * @readonly
 * @enum {object}
 */
export default {
	types
};
